import React, { Component } from 'react';
import SortableTree from '@nosferatu500/react-sortable-tree';
import {
    Row, Col,
    Card, CardBody, Collapse, Input, ListGroup, Button
} from 'reactstrap';
import './style.css'
import * as constant from '../../../Corporate/dashboard/constant';
class TreeStructure extends Component {
    constructor(props) {
        super(props);
        this.state = {
            treeData: this.props.treeData
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.treeData !== prevProps.treeData) {
            this.setState({
                treeData: this.props.treeData
            })
        }
    }

    handleNicBusinessSegmentRender(rowInfo){
        let nicBusinessSegmentRender;

        if (this.props.titleData.title === constant.NICSEGMENT){
            nicBusinessSegmentRender = <Row noGutters className="accord-header bg-light">
                <Col sm="4" className="p-3 accord-header__title border-bottom d-flex align-items-center segement-parent-wordwrap">
                    {rowInfo.node.nicCode? <span className="segment-wordwrap" title={rowInfo.node.nicCode}>{rowInfo.node.nicCode}</span> : <span className="segment-wordwrap" title={rowInfo.node.corporateName}>{rowInfo.node.corporateName}</span>}
                </Col>
                <Col sm="7" className="p-3 accord-header__title border-bottom d-flex align-items-center segement-parent-wordwrap">
                    <span className="segment-wordwrap" title={rowInfo.node.description}>{rowInfo.node.description}</span>
                </Col>
                <Col sm="7" xs="12" className="p-3 text-center accord-header__title border-bottom">
                    {Number(rowInfo.node.avgScore).toFixed(0)}&nbsp;<span className="d-block d-sm-none">Average Score</span>
                </Col>
                <Col sm="6" xs="12" className="p-3 text-center accord-header__title border-bottom cursor-pointer" onClick={() => this.props.handleMapFilter(rowInfo.node.corporateName, '', '', constant.COMPLETE)}>
                    {rowInfo.node.businessRelations}&nbsp;<span className="d-block d-sm-none">Business Relations</span>
                </Col>
            </Row>
        } else {
            nicBusinessSegmentRender = <Row noGutters className="accord-header bg-light">
                <Col sm="8" className="p-3 accord-header__title border-bottom d-flex align-items-center segement-parent-wordwrap">
                    <span className="segment-wordwrap" title={rowInfo.node.corporateName}>{rowInfo.node.corporateName}</span>
                </Col>
                <Col sm="8" xs="12" className="p-3 text-center accord-header__title border-bottom">
                    {Number(rowInfo.node.avgScore).toFixed(0)}&nbsp;<span className="d-block d-sm-none">Average Score</span>
                </Col>
                <Col sm="8" xs="12" className="p-3 text-center accord-header__title border-bottom cursor-pointer" onClick={() => this.props.handleMapFilter(rowInfo.node.corporateName, '', '', constant.COMPLETE)}>
                    {rowInfo.node.businessRelations}&nbsp;<span className="d-block d-sm-none">Business Relations</span>
                </Col>
            </Row>
        }
        
        return nicBusinessSegmentRender
    }
    
    render() {
        return (
            <SortableTree treeData={this.state.treeData}
                onChange={treeData => this.setState({ treeData })}
                rowHeight={160}
                canDrag={false}
                slideRegionSize={0}
                generateNodeProps={rowInfo => ({
                    buttons: [
                        <div key={rowInfo.node.corporateName} className="node d-flex position-relative selected node-view">{/*Add class="selected" at this level when company/user is selected*/}
                            <div key={rowInfo.node.corporateName} className='node-view'>
                                <div className="custom-table-header d-none d-sm-flex">
                                    {this.props.titleData.title === constant.NICSEGMENT? <Col sm="4" className="custom-table-header-title p-3">{this.props.titleData.title}</Col> : <Col sm="8" className="custom-table-header-title p-3">{this.props.titleData.title}</Col>}
                                    {this.props.titleData.title === constant.NICSEGMENT? <Col sm="7" className="custom-table-header-title p-3 text-center">Description</Col>: null}
                                    {this.props.titleData.title === constant.NICSEGMENT? <Col sm="7" className="custom-table-header-title p-3 text-center">Rubix Average Score</Col> : <Col sm="8" className="custom-table-header-title p-3 text-center">Rubix Average Score</Col>}
                                    {/*<Col sm="8" className="custom-table-header-title p-3 text-center">No of Companies</Col>*/}
                                    {this.props.titleData.title === constant.NICSEGMENT? <Col sm="6" className="custom-table-header-title p-3 text-center">Business Relations</Col>: <Col sm="8" className="custom-table-header-title p-3 text-center">Business Relations</Col>}
                                </div>
                                {this.handleNicBusinessSegmentRender(rowInfo)}
                                <div>
                                    <Collapse id={"ChildCollapse" + rowInfo.node.corporateName} className="show">
                                        <Card className="accord-body border-0">
                                            <CardBody className="p-0">
                                                <Row noGutters>
                                                    <Col xs="8" className="p-3 d-flex align-items-center flex-column flex-sm-row border-right border-bottom-danger-4 risk-distribution" onClick={() => this.props.handleApplyFilter(rowInfo.node.nicCode? rowInfo.node.nicCode: rowInfo.node.corporateName, 'HIGH')}>
                                                        <h3 className="mr-sm-3 risk-distribution__count">{rowInfo.node.riskLevelMap.HIGH}</h3>
                                                        <label className="risk-distribution__title text-center text-sm-left">High Risk</label>
                                                    </Col>
                                                    <Col xs="8" className="p-3 text-center align-items-center flex-column flex-sm-row border-right border-bottom-warning-4 risk-distribution" onClick={() => this.props.handleApplyFilter(rowInfo.node.nicCode? rowInfo.node.nicCode: rowInfo.node.corporateName, 'MEDIUM')}>
                                                        
                                                        <label className="risk-distribution__title text-center text-sm-left "><span className="mr-sm-3 risk-distribution__count">{rowInfo.node.riskLevelMap.MEDIUM}</span>Moderate Risk</label>
                                                    </Col>
                                                    <Col xs="8" className="p-3 text-center align-items-center flex-column flex-sm-row border-bottom-success-4 risk-distribution" onClick={() => this.props.handleApplyFilter(rowInfo.node.nicCode? rowInfo.node.nicCode: rowInfo.node.corporateName, 'LOW')}>
                                                        
                                                        <label className="risk-distribution__title text-center text-sm-left">
                                                        <span className="mr-sm-3 risk-distribution__count">{rowInfo.node.riskLevelMap.LOW}</span>Low Risk</label>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Collapse>
                                </div>
                            </div>
                        </div>
                    ],
                    style: {
                        height: '140px'
                    }
                })}
            />
        )
    }
}

export default TreeStructure